<template>
    <div style="padding:20px;">
        <h3>{{ tab_data.name }} Snippets</h3>
        <el-row style="margin-bottom:20px;">
            <el-col :span="24">
                <btn :icon="`fas fa-cloud-upload-alt`"
                     :click="save"
                     :cssClass="`btn btn-primary`">Save
                </btn>
            </el-col>
        </el-row>

        <el-row v-for="snippet in snippets"
                :key="`snippet-row-${employer_id}-${snippet.id}`"
                style="margin-bottom:20px;">
            <el-col :span="24">
                <label>{{ snippet.name }}</label>
                <el-input v-model="formValues[snippet.id]" :maxlength="snippet.id === 'salary' ? 10 : 255"/>
                <span class="help">{{ snippet.help }}</span>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <btn :icon="`fas fa-cloud-upload-alt`"
                     :click="save"
                     :cssClass="`btn btn-primary`">Save
                </btn>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props: [
        'tab_data',
        'employer_id',
        'snippets',
        'value',
    ],
    data() {
        return {
            formValues: this.value,
        };
    },
    watch: {
        formValues: {
            handler: function (newValue) {
                this.$emit('changed', { tab: this.tab_data.id, values: this.formValues });
            },
            deep: true,
        },
    },
    methods: {
        save() {
            this.$emit('save');
        },
    },
};
</script>

<style scoped>
.help {
    color: #666666;
    font-size: 0.8em;
    padding-top: 0.5em;
}
</style>